import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from '@app/service/header/header.service';
import { StateService } from 'src/app/service/state/state.service';
import { UserService } from 'src/app/service/user-service/user.service';
import { RouteComponent } from '../../route.component';
import { DeviceDetectorService, OS } from 'ngx-device-detector';

@Component({
  selector: 'app-de-email-verification',
  templateUrl: './de-email-verification.component.html',
  styleUrls: [
    '../../page-shared.css',
    './de-email-verification.component.scss',
  ],
})
export class DeEmailVerificationComponent
  extends RouteComponent
  implements OnInit
{
  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected headerService: HeaderService,
    private userService: UserService,
    private deviceDetectorService: DeviceDetectorService
  ) {
    super(router, route, stateService, headerService);
  }

  loading = true;
  showError: boolean = false;
  verificationCode: string;
  email: string;
  validVerificationCodeFormat = false;
  navigationInProgress = false;
  isMobile: boolean;
  IOS: boolean;
  otpLength = 4;

  onOtpChange(e: any) {
    this.showError = false;
    this.verificationCode = e;
    this.validVerificationCodeFormat = e.length === this.otpLength;
    if (this.validVerificationCodeFormat) {
      this.handleCtaClick();
    }
  }

  ngOnInit(): void {
    this.getinfo();
    this.isMobile = this.deviceDetectorService.isMobile();
    this.IOS = this.deviceDetectorService.getDeviceInfo().os === OS.IOS;
  }

  async getinfo() {
    await this.userService.sendEmailVerificationEmail();
    const userInfo = await this.userService.getActiveUserInfoDe();
    this.email = userInfo.email.value;
    this.loading = false;
  }

  async resendCode(): Promise<void> {
    try {
      await this.userService.resendEmailVerificationEmail();
    } catch (err) {
      this.handleError(err);
    }
  }

  async verifyCode() {
    try {
      const resp = await this.userService.verifyEmail(
        this.verificationCode && this.verificationCode.trim()
      );
      if (resp.success) {
        await this.navigate();
      } else {
        this.showError = true;
      }
    } catch (err) {
      this.handleError(err);
    }
  }

  async handleCtaClick() {
    if (this.navigationInProgress || !this.validVerificationCodeFormat) {
      this.showError = true;
    } else {
      this.navigationInProgress = true;

      await this.verifyCode();
    }
    this.navigationInProgress = false;
  }
}
